import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { FinnairBoundItem } from '@fcom/dapi/api/models';
import { Amount } from '@fcom/dapi/interfaces';

@Component({
  selector: 'fin-shopping-cart-bound',
  standalone: false,
  templateUrl: './shopping-cart-bound.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShoppingCartBoundComponent {
  bound = input.required<FinnairBoundItem>();
  selectedPassengerId = input<string | null>(null);
  price = input<Amount>();
  passengerCount = input<number>();

  openFareFamilyDetails = output<void>();
  openItineraryDetails = output<void>();
}
